import { useIntl } from 'react-intl';
import { generatePath } from 'react-router-dom';

import {
  Button,
  Props as ButtonProps,
} from '@sorare/core/src/atoms/buttons/Button';
import { FOOTBALL_PLAY_RIVALS_SQUADS_INVITE_JOINSECRET_USERSLUG } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSnackNotificationContext } from '@sorare/core/src/contexts/snackNotification';
import { useCopyToClipboard } from '@sorare/core/src/hooks/useCopyToClipboard';

type Props = { joinSecret: string } & Omit<ButtonProps, 'onClick'>;
export const ShareInviteSquadButton = ({ joinSecret, ...rest }: Props) => {
  const { showNotification } = useSnackNotificationContext();
  const { currentUser } = useCurrentUserContext();
  const copyToClipboard = useCopyToClipboard();
  const { formatMessage } = useIntl();

  if (!currentUser) return null;

  const onCopyLink = () => {
    copyToClipboard(
      `${formatMessage({
        id: 'Squad.InviteDialog.inviteMessage',
        defaultMessage: 'Join my Squad on Sorare!',
      })} ${window.origin}${generatePath(
        FOOTBALL_PLAY_RIVALS_SQUADS_INVITE_JOINSECRET_USERSLUG,
        {
          joinSecret,
          userSlug: currentUser.slug,
        }
      )}`
    );
    showNotification('copiedToClipboard');
  };

  return <Button {...rest} onClick={onCopyLink} />;
};
